import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Approach from './components/Approach';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

function App() {
  return (
    <>
      <Navbar />
      <div className='fullPage'>
        <Hero />
        <About />
        <Approach />
        <Projects />
        <Contact />
      </div>
    </>
  );
}

export default App;
